import { useQueryClient } from '@tanstack/react-query';

import { TRequestOptions } from '@/shared/api';
import {
  getIntegrationsByAccountId,
  IIntegrationsListResponseDto,
} from '@/shared/api/integrations';

const INTEGRATION_QUERY_KEY = 'integration';

export const integrationByAccountIdQuery = (
  accountId: string,
  options?: TRequestOptions
) => ({
  queryKey: [INTEGRATION_QUERY_KEY, 'list'],
  // The generated client types provider_type as a plain string; the UI model
  // keeps the known-provider union, so narrow the wire response here.
  queryFn: async (): Promise<IIntegrationsListResponseDto[]> =>
    (await getIntegrationsByAccountId(accountId, options)) as IIntegrationsListResponseDto[],
});

export const useInvalidateIntegrationByAccountId = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: [INTEGRATION_QUERY_KEY, 'list'],
    });
};
